import { render, staticRenderFns } from "./YetaiZiyuanFenxi.vue?vue&type=template&id=50fd3c16&scoped=true&"
import script from "./YetaiZiyuanFenxi.vue?vue&type=script&lang=js&"
export * from "./YetaiZiyuanFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd3c16",
  null
  
)

export default component.exports